import EventBus from "./event_bus";
import ResizeObserver from "resize-observer-polyfill";

const doc = document;
const styleClassName = "routed";

export const styleNav = idx => {
  let before = doc.querySelector(`nav ul >.` + styleClassName);
  let current = doc.querySelector(`nav ul > li:nth-child(` + idx + `)`);

  if (before) {
    if (before == current) {
      return;
    }
    before.classList.remove(styleClassName);
  }

  if (current) current.classList.add(styleClassName);
};

const resizeObserver = new ResizeObserver(([entry]) => {
  if (entry.contentRect.width < 1212) {
    EventBus.$emit("mobile", true);
  } else {
    EventBus.$emit("mobile", false);
  }
});

export const observeSizeOfApp = _ => {
  const app = doc.getElementById("app");
  resizeObserver.observe(app);
};



// WEBPACK FOOTER //
// ./src/js/style.js